import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import getItem from 'owa-mail-store/lib/services/getItem';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import ItemCLPInfo from 'owa-mail-store/lib/store/schema/ItemCLPInfo';
import Item from 'owa-service/lib/contract/Item';
import { getExtendedProperty } from 'owa-mail-store/lib/utils/getExtendedPropertyValue';
import mailStore from 'owa-mail-store/lib/store/Store';
import updateItemCLPInfo from '../utils/clp/updateItemCLPInfo';
import { LABEL_PROPERTY_NAME } from '../utils/clp/constants';
import getInitialItemCLPInfo from '../utils/clp/getInitialItemCLPInfo';

export default async function loadItemCLPInfo(itemId: string): Promise<ItemCLPInfo> {
    const clientItem = mailStore.items.get(itemId);
    if (clientItem) {
        if (!clientItem.itemCLPInfo) {
            return getItemCLPLabel(itemId).then(clpExtendedProperty => {
                updateItemCLPInfo(clientItem, clpExtendedProperty);
                return clientItem.itemCLPInfo;
            });
        }
        return Promise.resolve(clientItem.itemCLPInfo);
    }
    return Promise.resolve(getInitialItemCLPInfo());
}

async function getItemCLPLabel(itemId: string): Promise<ExtendedPropertyType> {
    return getItem(
        itemId,
        itemResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                extendedPropertyUri({
                    PropertyName: LABEL_PROPERTY_NAME,
                    DistinguishedPropertySetId: 'InternetHeaders',
                    PropertyType: 'String',
                }),
            ],
        }),
        null
    ).then((itemResp: Item) => {
        if (itemResp && !(itemResp instanceof Error)) {
            return getExtendedProperty(itemResp, null, LABEL_PROPERTY_NAME);
        }
        return null;
    });
}
